import { Form, Input } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { FieldValue } from 'app/components/commons/Hotel/Contacts/FieldView/FieldView';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import type { Hotel } from 'app/typings/hotels/Hotel/Hotel';

import { isSubCityRequired } from '../../../NewHotel/utils';

const RULES = [{ required: true }];

export const DisplayNames = () => {
  const { isEditMode } = useContext(ViewEditModeContext);

  const form = Form.useFormInstance<Hotel>();
  const city = Form.useWatch(['address', 'city'], form);
  const subCityRequired = isSubCityRequired(city ?? '');

  return (
    <>
      <FormLineLayout label="City" isRequired>
        <Form.Item
          name={['address', 'city']}
          rules={isEditMode ? RULES : undefined}
        >
          {isEditMode ? <Input id="display-names-city" /> : <FieldValue />}
        </Form.Item>
      </FormLineLayout>
      <FormLineLayout label="Subcity" isRequired={subCityRequired}>
        <Form.Item
          name={['address', 'subCity']}
          rules={
            !isEditMode
              ? undefined
              : subCityRequired
              ? [
                  { required: true },
                  {
                    pattern: /\S/,
                    message: 'Subcity cannot be empty or contain only spaces',
                  },
                ]
              : [
                  {
                    pattern: /\S/,
                    message: 'Subcity cannot contain only spaces',
                  },
                ]
          }
        >
          {isEditMode ? (
            <Input placeholder="Arrondissement or neighbourhood" />
          ) : (
            <FieldValue />
          )}
        </Form.Item>
      </FormLineLayout>
    </>
  );
};
